import { FilterSupportedType, StringValueId } from './filter-supported-type.model';
import { TranslateService, TranslateLoader } from '@ngx-translate/core';
import { Injector } from '@angular/core'; // Angular V5 use Injector directly
import { Observable } from 'rxjs/Observable';
import { getAppInjector } from '../../core/DI';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoaderJSONC } from '../translate-http-loader-jsonc';

export enum CategoryFilterType {
  Checkbox,
  Radio
}

// What the commonly information between all the filter that the backend send us
export interface ICategoryFilterBackend {
  name: string;
}

export interface ICategoryFilter extends ICategoryFilterBackend {
  type: CategoryFilterType; // Workaround for « typeof » , typeof (object) === "mytype" doesn't work has expected
  readonly showFilter: boolean;
  reset(); // Reset the category filter to a default state
  //resetByValue(valueToSelect: string); //Reset the filter to specified value
}

export abstract class CategoryFilter implements ICategoryFilter {
  protected translateService: TranslateService;
  name: string;
  type: CategoryFilterType; // Workaround for « typeof » , typeof (object) === "mytype" doesn't work has expected
  readonly showFilter: boolean;
  abstract reset(); // Reset the category filter to a default state
  //abstract resetByValue(valueToSelect: string);

  constructor() {

    const injector = Injector.create({ providers: [{ provide: TranslateLoader, useFactory: this.HttpLoaderFactory, deps: [HttpClient] }], parent: getAppInjector() });
    this.translateService = injector.get(TranslateService);
  }

  protected HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoaderJSONC(http);
  }

  get title(): Observable<string> {
    return this.translateService.get(`FC.Filters.${this.name}.title`);
  }
}
